// src/Dashboard/pages/user/PassageCeintureDocuments/utils/passageCeintureDocumentsUtils.js

export const DEFAULT_UI_STATE = {
  search: "",
  belt: "all",
  showDrafts: false,
  sort: "beltOrderTitle", // beltOrderTitle | belt | alpha
  perPage: 24,
};

const BELT_BASE = [
  "blanche",
  "jaune",
  "orange",
  "verte",
  "bleue",
  "marron",
  "noire",
];

export const strip = (value = "") =>
  String(value)
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();

export const beltRank = (ceinture = "") => {
  const value = strip(ceinture);

  const danMatch = value.match(/(\d+)\s*(?:er|e)?\s*dan/);
  if (danMatch) {
    const dan = parseInt(danMatch[1], 10) || 1;
    return 6 + dan;
  }

  const foundColors = BELT_BASE.map((color, index) =>
    value.includes(color) ? index : -1
  ).filter((index) => index >= 0);

  if (foundColors.length === 1) return foundColors[0];

  if (foundColors.length >= 2) {
    return foundColors.reduce((sum, item) => sum + item, 0) / foundColors.length;
  }

  const exactIndex = BELT_BASE.indexOf(value);
  if (exactIndex >= 0) return exactIndex;

  return Number.POSITIVE_INFINITY;
};

export const toAbsoluteUrl = (url) => {
  if (!url) return "";

  const value = String(url).trim();

  if (
    /^https?:\/\//i.test(value) ||
    value.startsWith("data:") ||
    value.startsWith("blob:")
  ) {
    return value;
  }

  if (!value.startsWith("/uploads")) {
    return value;
  }

  const base = process.env.REACT_APP_API_URL?.replace(/\/$/, "") || "";

  return `${base}${value}`;
};

export const isQuillEmpty = (html = "") => {
  const cleaned = String(html)
    .replace(/<p><br><\/p>/gi, "")
    .replace(/&nbsp;/gi, " ")
    .replace(/<[^>]*>/g, "")
    .trim();

  return !cleaned;
};

export const htmlToText = (html = "") => {
  if (!html) return "";

  if (typeof document === "undefined") {
    return String(html)
      .replace(/<[^>]+>/g, " ")
      .replace(/\s+/g, " ")
      .trim();
  }

  const div = document.createElement("div");
  div.innerHTML = html;

  return (div.textContent || div.innerText || "").replace(/\s+/g, " ").trim();
};

export const truncate = (value = "", max = 150) => {
  const text = String(value || "").trim();

  if (text.length <= max) return text;

  return `${text.slice(0, max)}…`;
};

export const getDocumentStatus = (document) => {
  return document?.is_published ? "published" : "draft";
};

export const getDocumentSearchText = (document) => {
  return [
    document?.titre,
    htmlToText(document?.description),
    document?.ceinture,
  ]
    .filter(Boolean)
    .join(" ")
    .toLowerCase();
};

export const normalizeBeltLabel = (belt) => {
  if (!belt) return "";

  if (typeof belt === "string") return belt.trim();

  return String(
    belt.label ||
      belt.nom ||
      belt.name ||
      belt.belt_name ||
      belt.couleur ||
      belt.color ||
      belt.belt ||
      ""
  ).trim();
};

export const getCurrentUserRoleId = () => {
  try {
    const userInfo = JSON.parse(localStorage.getItem("userInfo") || "{}");

    return (
      userInfo?.role_id ||
      userInfo?.roleId ||
      userInfo?.role ||
      userInfo?.user?.role_id ||
      null
    );
  } catch {
    return null;
  }
};

export const normalizePlainText = (value = "") => {
  return String(value || "").trim().replace(/\s+/g, " ");
};

export const normalizeRichText = (value = "") => {
  const html = String(value || "").trim();

  if (isQuillEmpty(html)) return "";

  return html;
};